import { render } from "./NotAuthView.vue?vue&type=template&id=3eb27c1a"
import script from "./NotAuthView.vue?vue&type=script&lang=js"
export * from "./NotAuthView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__